import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Container,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { Link, useParams } from 'react-router-dom';
import { urlConfig } from '../../../config/urlConfig';
import { sendRequest } from '../../../services/global/global.service';

const useStyle = makeStyles((theme) => ({
  link: {
    color: theme.ui.secondary,
    textDecoration: 'none',
    backgroundColor: '#fff',
    marginRight: 3,
    marginLeft: 3,
    '&:hover': {
      backgroundColor: '#fff',
    },
  },
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    height: 160,
  },
  title: {
    marginBottom: 24,
  },
  body: {
    fontSize: 20,
  },
  mizbanLogo: {
    width: 64,
    height: 64,
  },
  wrapper: {
    position: 'relative',
    margin: '10px 0',
    width: 'max-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonProgress: {
    color: '#000',
    position: 'absolute',
  },
}));

export const ConfirmEmailAddress = () => {
  const classes = useStyle();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(true);
  const [isVerify, setIsVerify] = useState(false);
  const { key } = useParams();

  useEffect(() => {
    setError(false);
    setLoading(true);
    sendRequest(`${urlConfig.account_confirm_email}/${key}/`, null, 'post', {
      key,
    })
      .then((res) => {
        setLoading(false);
        setIsVerify(true);
        setError(false);
      })
      .catch((e) => {
        setLoading(false);
        setIsVerify(false);
        setError(true);
      });
  }, [key]);

  return (
    <Container maxWidth='sm' className={classes.container}>
      <Box className={classes.container} mb={5}>
        <Avatar
          className={classes.mizbanLogo}
          src={process.env.PUBLIC_URL + '/icons/mizban.svg'}
        />
        <Typography color='primary' variant='h6'>
          Mizban
        </Typography>
      </Box>

      <Box className={classes.container} mb={5}>
        {error && (
          <Box className={classes.container} mb={5}>
            <Typography>
              The verification link you followed is expired.
            </Typography>
            <Typography>
              Please sign in again to re-send the verification email with a new
              link
            </Typography>
          </Box>
        )}
        {isVerify && (
          <Typography className={classes.body}>
            Your account has been verified successfully.
          </Typography>
        )}
      </Box>
      <Box mt={4} className={classes.wrapper}>
        <Button
          variant='contained'
          color='primary'
          component={Link}
          to='/signin'
          disabled={loading}
        >
          Sign in to mizban
        </Button>
        {loading && (
          <CircularProgress size={24} className={classes.buttonProgress} />
        )}
      </Box>
    </Container>
  );
};
